import { AccountJwt, accountJwt } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class Conf2AccountSignInResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    Conf2AccountSignInResponseDTO.validationSchema()
  );

  constructor(readonly value: Conf2AccountSignInResponseDTORaw) {
    JsonSchemaValidator.assert(Conf2AccountSignInResponseDTO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["token"],
      properties: {
        token: accountJwt
      },
      additionalProperties: false
    };
  }
}

export interface Conf2AccountSignInResponseDTORaw {
  token: AccountJwt;
}
